import { TOOL_TYPE } from './parsers/ToolType';

export type ToolStatus = 'started' | 'completed' | 'failed';

// Las herramientas que no tienen tarjeta en la burbuja (búsqueda web, recuperación de contenido)
// trabajan sin que el alumno lo vea, así que tampoco se le anuncian.
const DISPLAYED_TOOL_TYPES: ReadonlySet<string> = new Set([
  TOOL_TYPE.MERMAID_DIAGRAM,
  TOOL_TYPE.D3_VISUALIZATION,
  TOOL_TYPE.GEOGEBRA_VISUALIZATION,
  TOOL_TYPE.THREEJS_VISUALIZATION,
  TOOL_TYPE.CANVAS_GENERATION,
]);

const WAITING_MESSAGE_KEYS = [
  'chatbot:Creating something great for you',
  'chatbot:Preparing something useful for you',
  'chatbot:This will help, give me a moment',
  'chatbot:Your resource is on its way',
];

function hashIndex(seed: string, length: number): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash) % length;
}

export function isDisplayedToolEvent({ toolType }: { toolType?: string }): boolean {
  return toolType !== undefined && DISPLAYED_TOOL_TYPES.has(toolType);
}

/**
 * Clave i18n del mensaje de espera de una herramienta. Se elige por el `timestamp` del evento para
 * que la burbuja y el anuncio del lector de pantalla digan la misma frase.
 */
export function getToolMessageKey(status: ToolStatus, timestamp: string | undefined): string {
  if (status === 'failed') return 'chatbot:Error processing tool';

  return WAITING_MESSAGE_KEYS[hashIndex(timestamp ?? '', WAITING_MESSAGE_KEYS.length)];
}
